var PREFIX = "KButtonAction";
var classes = {
    actionButton: "".concat(PREFIX, "-actionButton"),
    disabled: "".concat(PREFIX, "-disabled")
};

export { classes };
//# sourceMappingURL=index.styled.js.map
